<template>
  <div :class="classesInput" style="width: 100%;margin: 0 auto;">
    <div  style="text-align: start;">
       <label class="label" style="text-align: center;margin: 0 auto;display: block;">
          <span class="checkmarkv2" :class="{'checkmarkv2Checked': value}" @click="value = !value"></span>
          <span style="margin-left: 40px; max-height: 80px; display: inline-block; overflow: auto;text-align: justify;padding: 1px 10px;" :style="{'color':labelColor}">
            {{label}}
          </span>
        </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFormCheckbox',
  status: 'prototype',
  release: '1.0.0',
  inheritAttrs: false,
  props: {
    initialValue: {
      required: false,
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelColor:{
      type: String,
      default: null,
      required: false    
    }
  },
  data () {
    return {
      value: this.initialValue
    }
  },
  computed: {
    classesInput () {
      return {
        'input-wrapper': true,
        'input--is-dirty': this.isDirty,
        'input--is-disabled': this.disabled,
        'input--is-readonly': this.readonly
      }
    }
  },
  watch: {
    value (val) {
      this.$emit('valueChanged', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.input-wrapper {
  padding-top: 2px;

  .label {
    font-family: $font-text;
    font-size: $size-xs;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    color: $color-purple-darker;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    &:checked ~ .checkmark {
      border: solid 6px $color-purple-light;
    }
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border-radius: 50%;
    border: solid 1px rgb(208, 208, 208);
    background-color: $color-white;
    &:after {
      content: "";
      position: absolute;
      display: none;
    }
  }
}
.checkmarkv2 {
  box-shadow: 8px 3px 14px -3px rgba(227, 227, 227, 0.66);
  position: absolute;height: 20px;width: 20px;background-color: $color-white;border: 2px solid gray;border-radius: 70%;
}
.checkmarkv2Checked {
  border: solid 3px $color-gray;
}
</style>
